const devProxy = {
  api: 'https://testapi.roombox.xdf.cn',
  // api: 'http://api.mk.metcom.com.cn',
  // api: 'https://api.roombox.xdf.cn',
  pan: 'http://testpan.coursebox.xdf.cn',
  // ss: 'https://webapps.mk.metcom.com.cn/ss',
  ss: "https://testss.roombox.xdf.cn"
}

class Hosts {
  location = {
    protocol: window.location.protocol,
    host: window.location.host,
  }
  constructor() {
    this.apiUrl = this.api();
    this.panUrl = this.pan();
    this.ssUrl = this.ss();
  }
  api = () => {
    const protocol = this.location.protocol;
    const host = this.location.host;
    if (process.env.NODE_ENV === 'development') {
      return devProxy.api;
    } else if (host.includes('testd')) {
      return `${protocol}//testapi.roombox.xdf.cn`;
    } else if (host.includes('test2d')) {
      return `${protocol}//test2api-roombox.test.xdf.cn`;
    } else if (host.includes('test3d')) {
      return `${protocol}//test3api-roombox.test.xdf.cn`;
    } else if (host.includes('metcom')) {
      return `${protocol}//api.mk.metcom.com.cn`;
    } else {
      return 'https://api.roombox.xdf.cn';
    }
  }
  pan = () => {
    const protocol = this.location.protocol;
    const host = this.location.host;
    if (process.env.NODE_ENV === 'development') {
      return devProxy.pan;
    } else if (host.includes('testd')) {
      return `${protocol}//testpan.coursebox.xdf.cn`;
    } else if (host.includes('test2d')) {
      return `${protocol}//test2pan-roombox.test.xdf.cn`;
    } else if (host.includes('test3d')) {
      return `${protocol}//test3pan-roombox.test.xdf.cn`;
    } else if (host.includes('metcom')) {
      return `${protocol}//pan.mk.metcom.com.cn`;
    } else {
      return 'https://pan.coursebox.xdf.cn';
    }
  }
  ss = () => {
    const host = this.location.host;
    if (process.env.NODE_ENV === 'development') {
      return devProxy.ss;
    } else if (host.includes('testd')) {
      return 'https://testss.roombox.xdf.cn';
    } else if (host.includes('metcom')) {
      return 'https://webapps.mk.metcom.com.cn/ss';
    } else {
      return 'https://ss.roombox.xdf.cn';
    }
  }
}

export default new Hosts();